export class ImagensUsuarioPerfilModel {

  imgUsuario?: any;
  imgBase64?: string;
  extensaoImg?: string;

}
